
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/precon/[precon]/[commander]",
      function () {
        return require("private-next-pages/precon/[precon]/[commander].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/precon/[precon]/[commander]"])
      });
    }
  